// extracted by mini-css-extract-plugin
module.exports = {"AbsoluteQuiz":"MoreDropdown_AbsoluteQuiz__3O6B7","AbsoluteProfile":"MoreDropdown_AbsoluteProfile__Sk72e"};